import { Deserializable } from '../../protocols/deserializable';

export class ProductTag implements Deserializable {
  public companyId: number;
  public id: string;
  public name: string;
  public description: string;
  public groupId: string;
  public isPOS: boolean = false;
  public isCurated: boolean = false;
  public deletedAt: number;
  public dateCreated: number;
  public lastModified: number;

  onDeserialize() {}

  isVisibleTag(enabledCuratedProductTagGroupIds: string[], enabledCuratedProductTagIds: string[]): boolean {
    if (this.isCurated) {
      return enabledCuratedProductTagGroupIds?.includes(this.groupId) || enabledCuratedProductTagIds?.includes(this.id);
    }
    return true;
  }
}
